import { render } from "./social-carousel.vue?vue&type=template&id=2b4529f5"
import script from "./social-carousel.vue?vue&type=script&lang=js"
export * from "./social-carousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__